import type { LicenseFormVisitType, ServiceType } from './LicenseFormSchema'

/** Trim service name suffix like " - GP" */
function cleanServiceName(name: string): string {
  const dashIdx = name.lastIndexOf('-')
  return dashIdx !== -1 ? name.substring(0, dashIdx).trim() : name
}

/** Flatten ServiceType[] into form visit type array, filtering hidden types (Gap 8) */
export function flattenServiceTypes(serviceTypes: ServiceType[]): LicenseFormVisitType[] {
  return serviceTypes.flatMap((st) =>
    st.VisitTypes.filter((vt) => vt.VisibilityType !== 'none' && vt.VisibilityType !== 'deeplink').map((vt) => ({
      visitTypeId: vt.VisitTypeId,
      serviceName: cleanServiceName(st.Name),
      visitName: vt.Name,
      isSelected: false,
      visibilityOverride: 'all',
    })),
  )
}
